import { render, staticRenderFns } from "./CKBasicEditor.vue?vue&type=template&id=eb68f05c"
import script from "./CKBasicEditor.vue?vue&type=script&lang=js"
export * from "./CKBasicEditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CKBasicEditor.vue?vue&type=style&index=1&id=eb68f05c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports